import React from 'react';
import { Checkbox, FormControlLabel } from '@mui/material';

import { humanCase } from '@paragon/utilities';

import { PropertyComponentProps } from './ModelProperty';

export function BooleanPropertyComponent(props: PropertyComponentProps<boolean>) {
  return (
    <FormControlLabel
      control={
        <Checkbox
          color="default"
          checked={props.value}
          onChange={(_, checked) => {
            props.onEdit(checked);
          }}
        />
      }
      label={humanCase(props.name)}
      disabled={props.configuration.disabled}
    />
  );
}
